/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export interface Modal {
  id: string;
  type: string;
  data: object;
  config?: {
    ignoreUrl?: boolean;
  };
  context?: string;
}

export interface ModalWithCallbacks extends Modal {
  resolve: Function;
  reject: Function;
}

export enum ModalSize {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
}
